module.exports = __webpack_public_path__ + "static/intro-bg-ae325706d3bf849f4aa0e721315b83db.jpg";